import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { google_auth, get_current_user } from "../../redux/actions";
import GoogleLogin from "react-google-login";
import useWindowDimensions from "../../util/useWindowDimensions";
import { Container, Row, Col } from "react-bootstrap";
require("dotenv");

export default function LoginRegistration() {
  const { _, width } = useWindowDimensions();
  const dispatch = useDispatch();
  const globalState = useSelector(state => state);
  const history = useHistory();

  function responseGoogle(response, status) {
    if (status === "success") {
      dispatch(
        google_auth(
          `${process.env.REACT_APP_URL}/api/googleAuth`,
          { idToken: response.tokenObj.id_token },
          "post"
        )
      );
    } else if (status === "failure") {
      console.log("Google Auth Failure ", response);
    }
  }

  useEffect(() => {
    if(globalState.isAuthenticated) {
      history.push("/");
    }
  }, [globalState.isAuthenticated])

  return (
    <Container fluid>
      <Row>
        <Col sm={4} md={4} className="common-col col1">
          <div className="min-vh-100 align-items-center justify-content-center d-flex comnpany-info">
            <div>
              <h1 className="text-light text-weight-bold">DevUnity</h1>
              {width <= 576 && (
                <h3 className="text-light text-weight-bold">
                  <a
                    className="login-registration-link"
                    href="#login-registration-section"
                  >
                    Click here to Login/Register below
                  </a>
                </h3>
              )}
            </div>
          </div>
        </Col>
        <Col
          id="login-registration-section"
          sm={8}
          md={8}
          className="common-col col2"
        >
          <div className="right-side-container d-flex min-vh-100 align-items-center justify-content-center">
            <div className="row-container justify-content-center">
              <h3 className="text-center text-light mb-3">
                Please Log In, or Sign Up
              </h3>
              <Row className="row-1">
                {/* <Col sm={6} md={6} className="mb-5 mb-sm-0 mb-md-0 text-center">
                  <button className="btn btn-lg btn-primary w-100">
                    Facebook
                  </button>
                </Col> */}
                {/* <Col sm={6} md={6} className="text-center"> */}
                <Col className="text-center">
                  <GoogleLogin
                    clientId={
                      process.env.REACT_APP_GOOGLE_LOGIN_REGISTRATION_CLIENT_ID
                    }
                    render={(renderProps) => (
                      <button
                        onClick={renderProps.onClick}
                        className="btn btn-lg btn-warning w-100"
                      >
                        Google
                      </button>
                    )}
                    buttonText="Login"
                    onSuccess={(res) => responseGoogle(res, "success")}
                    onFailure={(res) => responseGoogle(res, "failure")}
                    cookiePolicy={"single_host_origin"}
                  />
                </Col>
              </Row>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}
